module.exports = __webpack_public_path__ + "img/banner3.cc8bc2a4.jpg";